
    <div class="alert-facade-default-widget">
      <pre *ngIf="entity">
            {{ entity.toJson() | json }}
        </pre
      >
    </div>
  